/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-08 11:11:44
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-30 15:42:29
 */
import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import './style.css'
import { message } from 'antd'
import Axios from 'axios'
import axios from "axios";
import { transformtime } from 'src/utils/tools'
import { Link } from "react-router-dom";
import HomeHearder from './HomeHearder';
import { FirstPage, ServicePage, StationNet, AppScene, AchievementDisplay, NewsRecommend } from './compontent/index';
import {
    navigationList, statisticsDatas, servicePageList, stationNetSystemList, stationNetCarouselList,
    appSceneList, achievementDisplayList, NewsRecommendList
} from './Datas/normalDatas'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'

var getnews = async (page, limit) => {
    return new Promise((resolve, reject) => {
        // Axios.get(`${global.url.news}/news/getNews/${limit}/${page}`)
        Axios.get(`${global.url.news}/news/page2?limit=${limit}&page=${page}`)   // ---  -- 换成我
            .then(res => {
                console.log("getnews----", res.data);
                resolve(res.data.payload.records)
            })
    })

}

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],
            nowClickNavigationIndex: 0,  //当前选择的导航栏index
            initData: {},
            statisticsDatas: [
                {
                    num: "0",
                    type: "颗",
                    name: "遥感卫星",
                    icon: "images/tempImgs/走马灯/统计/1.png"
                },
                {
                    num: "0",
                    type: "条",
                    name: "真值数据",
                    icon: "images/tempImgs/走马灯/统计/5.png"
                },
                {
                    num: "0",
                    type: "TB",
                    name: "卫星数据",
                    icon: "images/tempImgs/走马灯/统计/5.png"
                },
                {
                    num: "0",
                    type: "TB",
                    name: "数据存量",
                    icon: "images/tempImgs/走马灯/统计/4.png"
                },
                {
                    num: "0",
                    type: "景",
                    // name: "影像产品",
                    name: "共性产品",
                    icon: "images/tempImgs/走马灯/统计/2.png"
                },
                {
                    num: "0",
                    type: "个",
                    name: "模型工具",
                    icon: "images/tempImgs/走马灯/统计/3.png"
                },
            ],
            onlineUsers:0,
            visit:0,
            achievementDisplayList:achievementDisplayList
        }
        this.initData();
    }

    async initData() {
        let news = await getnews(1, 4);
        this.setState({ news });
    }

    componentDidMount() {
        this.initScroll();
        this.visitLog()
        this.getOnlineUsers()
        this.getVisit()
        this.getAchievementDisplayList()
        axios.get(global.gatewayip + "/api/interface/api/getSatProdToolData").then(
            r => {
                // console.log("卫星数据信息：", r.data.payload);
                let data = r.data.payload;
                let GB = 1048576;//换算原数据有多少GB
                let TB = 1073741824;//换算原始数据有多少TB
                let resource = this.state.statisticsDatas;
                resource[0].num = data.satNum;//设置卫星数量
                resource[4].num = data.prodNum;//设置产品数量
                resource[5].num = data.toolNul;//设置工具数量
                // 设置数据量
                let dataSize = data.dataSum;
                resource[3] = this.getDataSize(resource[3], dataSize);
                // if (dataSize / TB < 100) {
                //     resource[3].type = "GB";
                //     resource[3].num = (dataSize / GB).toFixed(2);
                // } else {
                //     resource[3].num = (dataSize / TB).toFixed(2);
                //     resource[3].type = "TB";
                // }
                let setDataSize = data.satDataSum;
                // resource[4] = this.getDataSize(resource[4], setDataSize)
                resource[2].num = setDataSize / 10000
                resource[2].type = "万景"
                // if (setDataSize / TB < 100) {
                //     resource[4].type = "GB";
                //     resource[4].num = (setDataSize / GB).toFixed(2);
                // } else {
                //     resource[4].num = (setDataSize / TB).toFixed(2);
                //     resource[4].type = "TB";
                // }
                let { siteDataNum } = data;
                // resource[5]=this.getDataSize(resource[5],siteDataNum)
                if (siteDataNum > 10000) {
                    resource[1].type = '万条';
                    resource[1].num = Math.round(siteDataNum / 10000);
                }
                this.setState({ statisticsDatas: resource });
            }
        )
    }

    visitLog = async () => {
        await axios.post(`${window.url.sys}/sys/log/saveVisit`)
    }

    getOnlineUsers = async () => {
        await axios.get(`/gateway/api/interface/ygRole/omas/user/loginInfo/withRedis`).then(res=>{
            this.setState({
                onlineUsers: res.data.payload
            })
        });
    }

    getVisit = () => {
        axios.post(`/gateway/api/system-manager/sys/log/getVisit`).then(res=>{
            this.setState({
                visit: res.data.payload
            })
        });
    }

    getAchievementDisplayList = async () => {
        await axios.get(`/gateway/api/online-school/collection/page?limit=4&page=1`).then(res=>{
            this.setState({
                achievementDisplayList: res.data.data.records
            })
        });
    }

    getDataSize = (item, dataSizeNum) => {
        let GB = 1048576;//换算原数据有多少GB
        let TB = 1073741824;//换算原始数据有多少TB
        let newItem = { ...item }
        if (dataSizeNum / TB < 100) {
            newItem.type = "GB";
            newItem.num = (dataSizeNum / GB).toFixed(2);
        } else {
            newItem.num = (dataSizeNum / TB).toFixed(2);
            newItem.type = "TB";
        }
        return newItem;
    }

    returnShowPage = () => {
        const { nowClickNavigationIndex } = this.state;
        switch (nowClickNavigationIndex) {
            case 0:
                return (
                    <Fragment>
                        <HomeHearder />
                        <FirstPage data={this.state.statisticsDatas} onlineUsers={this.handleNum(this.state.onlineUsers)} visit={this.handleNum(this.state.visit)}/>
                    </Fragment>
                )
            case 1:
                return <ServicePage data={servicePageList} />;
            case 2:
                return <StationNet data={{ systemList: stationNetSystemList, carouselList: stationNetCarouselList }} />;
            case 3:
                return <AppScene data={appSceneList} />;
            case 4:
                return <AchievementDisplay data={this.state.achievementDisplayList} />;
            case 5:
                return <NewsRecommend data={NewsRecommendList} news={this.state.news} />;
            default:
                message.error("导航栏识别错误！");
                break;
        }
    }

    onClickNavigation = (navigation, index) => {
        // this.setState({ nowClickNavigationIndex: index });
        this.jumpToMenu(navigation);
    }
    initScroll = () => {
        // window.addEventListener("scroll", (e) => {
        document.getElementById("HomePageMain").addEventListener("scroll", (e) => {
            var scroll = document.getElementById("HomePageMain").scrollTop || document.body.scrollTop;
            var sections = document.querySelectorAll('.HomePageMainScroll .HomePageContent');
            for (var i = sections.length - 1; i >= 0; i--) {
                if (parseInt(scroll) >= Math.ceil(sections[i].offsetTop) - 20) {
                    this.setState({ nowClickNavigationIndex: i });
                    return;
                }
            }
        })
    }

    //点击左下角导航栏，跳转至对应位置
    jumpToMenu = (word) => {
        document.getElementById(`#${word}`).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        })
    }

    returnClass = (index) => {
        if(this.state.nowClickNavigationIndex % 2 !== 0) {
            if(this.state.nowClickNavigationIndex === index) {
                return 'HomePage_NavigationText_Select HomePage_NavigationText_Select_Blue'
            } else {
                return 'HomePage_NavigationText HomePage_NavigationText_Blue'
            }
        } else {
            if (this.state.nowClickNavigationIndex === index) {
                return 'HomePage_NavigationText_Select'
            } else {
                return 'HomePage_NavigationText'
            }
        }
    }

    handleNum = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {
        const { nowClickNavigationIndex } = this.state;
        return (
            <div className='HomePage'>
                <div className='HomePageMain' id='HomePageMain'>
                    <div className='HomePageMainScroll'>
                        {/* {this.returnShowPage()} */}
                        <HomeHearder />
                        <div className='HomePageContent' id={`#${navigationList[0]}`}><FirstPage
                            data={this.state.statisticsDatas} onlineUsers={this.handleNum(this.state.onlineUsers)} visit={this.handleNum(this.state.visit)}/></div>
                        <div className='HomePageContent' id={`#${navigationList[1]}`}><ServicePage
                            data={servicePageList} /></div>
                        <div className='HomePageContent' id={`#${navigationList[2]}`}><StationNet
                            data={{ systemList: stationNetSystemList, carouselList: stationNetCarouselList }} /></div>
                        <div className='HomePageContent' id={`#${navigationList[3]}`}><AppScene data={appSceneList} />
                        </div>
                        <div className='HomePageContent' id={`#${navigationList[4]}`}><AchievementDisplay
                            data={this.state.achievementDisplayList} /></div>
                        <div className='HomePageContent' id={`#${navigationList[5]}`}><NewsRecommend
                            data={NewsRecommendList} news={this.state.news} /></div>
                        <MainBottom data={unitsList} />
                    </div>
                </div>

                <div className='HomePage_Navigation'>
                    <div className={nowClickNavigationIndex % 2 == 0 ? 'HomePage_NavigationList' : 'HomePage_NavigationList HomePage_NavigationList_Blue'}>
                        {navigationList.map((navigation, index) => {
                            return (
                                <div
                                    className={this.returnClass(index)}
                                    id={`nav_${index}`}
                                    onClick={() => this.onClickNavigation(navigation, index)}>
                                    {navigation}
                                </div>
                            )
                        })}
                    </div>
                    {/* <img className='HomePage_NavigationMore' src={"images/HomePage/more.png"} /> */}
                    <div className={nowClickNavigationIndex % 2 == 0 ? 'HomePage_NavigationMore' : 'HomePage_NavigationMore HomePage_NavigationMore_Blue'}><span className='HomePage_NavigationMore_Text'>{'->'}</span></div>
                </div>
                {/*新闻*/}
                {/* {this.state.news.map((data, index) =>
                        <div key={index} className='news-p1'>
                            <div className='news-contentpanel'>
                                <img alt='' className='home-p6-img1' src={require('./img/background-1.png')} />
                                <img alt='' className='home-p6-img2' src={require('./img/satellite.png')} />
                                <div className='home-p6-img3-back'>
                                </div>
                                <img alt='' className='home-p6-img3' src={data.thumbnail} />
                                <div className='home-p6-text1'>
                                    {data.title}
                                </div>
                                <div className='home-p6-text2'>
                                    {transformtime(data.created, 'yyyy-mm-dd')}
                                </div>
                                <div className='home-p6-bar1'>
                                </div>
                            </div>
                        </div>)
                    } */}
                {/* <Link to={{ pathname: "/UserLogin", state: { to: "/sensing" } }}>
                    <div className='home-p2-text1'>
                        {'共性产品检验'}
                    </div>
                </Link> */}
            </div>)

    }
}

export default Home